import { render, staticRenderFns } from "./ProductCreate.vue?vue&type=template&id=1210706d&scoped=true"
import script from "./ProductCreate.vue?vue&type=script&lang=js"
export * from "./ProductCreate.vue?vue&type=script&lang=js"
import style0 from "./ProductCreate.vue?vue&type=style&index=0&id=1210706d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1210706d",
  null
  
)

export default component.exports